  $('.video-slider-result').slick({
  dots: false,
  infinite: true,
  arrows: false,
  speed: 300,
  slidesToShow: 2.4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

 $('.play-button').click(function() {
    var $video = $(this).siblings('video').get(0); // Get the associated video element

    if ($video.paused) {
      $video.play();
      $(this).hide(); // Hide the play button when the video is playing
    }
  });

  // Handle video click to pause
  $('video').click(function() {
    if (!this.paused) {
      this.pause(); // Pause the video
      $(this).siblings('.play-button').show(); // Show the play button when the video is paused
    }
  });

  // Ensure the play button reappears when the video ends
  $('video').on('pause', function() {
    $(this).siblings('.play-button').show();
  });



// marque----------

    document.addEventListener("DOMContentLoaded", function() {
        const toggle = document.getElementById("toggleDirection");
        const marquees = document.querySelectorAll(".component-marqueeee-left");

        toggle.addEventListener("change", function() {
            marquees.forEach(marquee => {
                if (toggle.checked) {
                    marquee.classList.add("reverse"); // Moves right
                } else {
                    marquee.classList.remove("reverse"); // Moves left
                }
            });
        });
    });








